import { OrderMetricsReducerState, OrdersReducerState } from './types';

export const initialState: OrdersReducerState = {
  order: null,
  tax: null,
  createdOrderId: null,
  bucketFiles: [],
  deliveryDate: {
    value: '',
    hasError: false,
  },
  installDate: {
    value: '',
    hasError: false,
  },
};

export const initialStateOrderMetric: OrderMetricsReducerState = {
  count: 0,
};
